
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


const common = (($) => {
  "use strict";

  const handleMobileMenu = () => {

    $("#menu-mobile-menu > li.menu-item-type-custom").on("click", function() {
      // $(this).toggleClass("menu-active");
    });
   };

   $('.menu-item-has-children').each(function() {
      $(this).click(function() {
          console.log($(this))
          if ($(this).find('.sub-menu').hasClass('expanded')) {
              $(this).removeClass('sub-menu--open').find('.sub-menu').removeClass('expanded');
          } else {
              $(this).addClass('sub-menu--open').find('.sub-menu').addClass('expanded');
          }
      })
  });


  const handleRequestQuoteForm = () => {
    $('.form-select').on('change', function () {
      let formSelect = $(this).val()
      console.log(formSelect);
      $('.report-forms div').removeClass('showBox')
      $('.' + formSelect).addClass('showBox')
    });
    $('input[type="checkbox"]').on('click', function () {
      console.log($(this).val());
      if ($(this).val() === "Energy Performance Certificate (EPC)" && $(this).is(':checked')) {
          $('.estimate').hide();
      } else {
          $('.estimate').show();
      }

      if(($('#forSale').is(':checked') && $('#forRent').is(':checked')) || $(this).val() === 'all'){
          $('#forSale').prop('checked', false);
          $('#forRent').prop('checked', false);
          $('#allProp').prop('checked', true);
      } else if(($('#forSale').is(':checked') || $('#forRent').is(':checked')) && $('#allProp').is(':checked'))  {
          $('#allProp').prop('checked', false);
      } else if(!($('#forSale').is(':checked') && $('#forRent').is(':checked')) ){
          $('#allProp').prop('checked', true);
      }
    });
    document.addEventListener( 'wpcf7mailsent', function( event ) {
      document.getElementsByClassName('form-select')[0].style.display = 'none';
      document.getElementsByClassName('form-select-label')[0].style.display = 'none';
      $('.home-reports').hide();
      $('.commercial').hide();
      $('.building').hide();
      $('.planning').hide();
      $('.alert-box-confirm').hide();
      // Redirect to thank you page
      window.location.href = "/thank-you/";
    });
  };

  const handleProperties = () => {
    //window.FontAwesomeConfig.searchPseudoElements = true;

    $('.internal-container').last().addClass('last');

    $("#toggle-filter").click(function() {
        var currentClass = $(this).attr('class');
        $(this).text(
            (currentClass === 'collapsed' || currentClass === undefined) ? 'Hide Filter' : 'Show Filter'
        );
    });


    $('[data-toggle="tooltip"]').tooltip();

    $('.show-more').click(function() {
        if ($('.extra-options').hasClass('show-options')) {
            $('.extra-options').removeClass('show-options');   
            $('.show-more').html('Show More Filters');
        } else {
            $('.extra-options').addClass('show-options');
            $('.show-more').html('Hide More Filters');
        }
    });

    window.doingAjax = false;

    if ($(".properties").length > 0) {
        var page = 2;

        $('.more-properties').on('click', function() {

            if ($('.end').length <= 0) {
                $('.more-properties').html('Loading...');

                const bottomOffset = 1000;
                const saleType = getUrlParameter('propertySale');
                const propType = getUrlParameter('propertyType');
                const propLocation = getUrlParameter('propertyLocation');
                const propRegion = getUrlParameter('propertyRegion');
                const minSize = getUrlParameter('minSize');
                const maxSize = getUrlParameter('maxSize');
                const minPrice = getUrlParameter('propertyMinPrice');
                const maxPrice = getUrlParameter('propertyMaxPrice');
                const propKeywords = getUrlParameter('propertyKeywords');
                const propOwner = getUrlParameter('propertyOwner');
                const otherType = getUrlParameter('otherType');

                if (!window.doingAjax) {

                    window.doingAjax = true;

                    $.ajax({
                        type: "POST",
                        data: ({
                            action: "search_results",
                            paged: page,
                            propertySale: saleType,
                            propertyType: propType,
                            propertyLocation: propLocation,
                            propertyRegion: propRegion,
                            propertyMinSize: minSize,
                            propertyMaxSize: maxSize,
                            propertyMinPrice: minPrice,
                            propertyMaxPrice: maxPrice,
                            propertyKeywords: propKeywords,
                            propertyOwner: propOwner,
                            otherType: otherType
                        }),
                        url: "/wp-admin/admin-ajax.php",
                        dataType: 'html',
                        success: function(data) {
                            console.log("Success");
                            page++;
                            $('#response').append(data).hide().fadeIn();
                            // if data contains "nomoreresults" then hide the button
                            if (data.indexOf("nomoreresults") > -1 || data === "") {
                              $('.more-properties').hide()
                            } else {
                              $('.more-properties').html('Show More');
                            }
                            window.doingAjax = false;
                            return false;
                        }
                    });
                }
            }
        })
    }

    const minPrice = getUrlParameter('propertyMinPrice');
    const maxPrice = getUrlParameter('propertyMaxPrice');

    const handleExtraOptions = (value) => {
      
      $("select[name=propertyMinPrice] option").remove();
      $("select[name=propertyMaxPrice] option").remove();
      $("select[name=propertyMinPrice]").append(`<option value="" default>Min Price</option>`);
      $("select[name=propertyMaxPrice]").append(`<option value="" default>Max Price</option>`);

      let optionsMin = "";
      let optionsMax = "";
      if(value == "for_sale") {
        optionsMin = $("select[name=propertyMinPrice]").data('sale').split(',');
        optionsMax = $("select[name=propertyMaxPrice]").data('sale').split(',');
      } 
      if(value == "for_rent") {
        optionsMin = $("select[name=propertyMinPrice]").data('rent').split(',');
        optionsMax = $("select[name=propertyMaxPrice]").data('rent').split(',');
      }
      if(optionsMin == '') {
        return;
      }
      
      optionsMin.forEach(option => {
        const isCurrent = option == minPrice;
        $("select[name=propertyMinPrice]").append(`<option ${isCurrent ? 'selected' : ''} value="${option}">£${option.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</option>`);
      });

      optionsMax.forEach(option => {
        const isCurrent = option == maxPrice;
        $("select[name=propertyMaxPrice]").append(`<option ${isCurrent ? 'selected' : ''} value="${option}">£${option.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</option>`);
      });

      $("select[name=propertyMinPrice]").removeAttr("disabled");
      $("select[name=propertyMaxPrice]").removeAttr("disabled");
    };

    handleExtraOptions($("select[name=propertySale]").val());

    $("select[name=propertySale]").on("change", function() {
      const value = $(this).val();
      handleExtraOptions(value);
    });

  };

  const handleSwiper = () => {
    if ($('.swiper-container').length > 0) {

      window.galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        loop: true,
      });
      
      $(".gallery-thumbs .swiper-slide").on("click", function() {
        window.galleryTop.slideTo($(this).data('index'));
      });
      $(".swiper-button-prev").on("click", function() {
        window.galleryTop.slidePrev();

      });
      $(".swiper-button-next").on("click", function() {
        window.galleryTop.slideNext();
      });
  
    }
    ///** Fixes issue with slider not initializing properly in IE **///
    $(window).on("load", function() {
        if ($('.swiper-container').length > 0) {
            $('.photos').removeClass('show');
        }
    });
  
  };

  const handleLoadMoreVacancies = () => {
    $('.loadmorevacancies').on("click", function() {
      $(".careerslist__card").removeClass("hidden");
      $('.loadmorevacancies').hide();
    });
  };


  //checks that a date is in format dd/mm/yyyy
  const isValidDate = (date) => {
    var matches = /^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/.exec(date);
    if (matches == null) return false;
    return true;
  };

  
  const formValidation = () => {
    $(".form_error").hide();
    
    $('#selectbasic').on("change", function() {
      $(".invoice_office__error").hide();
    });

    $('#home-report-form').on('submit', function() {
      let invoiceDate = $('#invoice_date').val();
      let invoiceDateValid = isValidDate(invoiceDate);

      let officeSelected = $('#selectbasic').val();

      

      if(officeSelected == "not_selected") {
        $(".invoice_office__error").show();
        return false;
      }

      if(!invoiceDateValid) {

        $(".invoice_date__error").show();

          return false;
      }
    });
  };

  // Checks that the user age is more than 18 using day, month, year
  const checkAge = (day, month, year) => {
    var today = new Date();
    var birthDate = new Date(year, month, day);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age >= 18;
  };
  
  const handleVirtualVisit = () => {
    const vimeoButtonSelector = ".btn.btn-primary.modal-link";
    if($(vimeoButtonSelector).length > 0) {
      $(vimeoButtonSelector).on("click", function() {

        const videoId = $(this).data("video-id");

        $("#vimeo-modal").show();
        $(".modal-body").html(`<iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`);

      });

      $("#vimeo-modal .modal-close, #vimeo-modal .modal-content").on("click", function() {
        $("#vimeo-modal").hide();
        $(".modal-body").html("");
      })

    }
  }

  /**
   * Fire events on document ready and bind other events
   *
   * @since   1.0.0
   */
  const ready = () => {
    handleMobileMenu();
   // handleRequestQuoteForm();
    handleProperties();
    handleSwiper();
    handleLoadMoreVacancies();
    handleVirtualVisit();

    // if ($('#invoice_date').length > 0) {
    //   TinyDatePicker('#invoice_date', {
    //       format(date) {
    //           return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    //       },
    //       parse(str) {
    //           const parts = str.split(',').join('/').split('.').join('/').split('-').join('/').split('/');
    //           const date = new Date(parts[2], (parts[1] - 1), parts[0]);
    //           return isNaN(date) ? new Date() : date;
    //       },
    //   });
    // }

    document.addEventListener( 'wpcf7mailsent', function( event ) {
      if ( '9114' == event.detail.contactFormId ) {
        window.location.href = "/thank-you/";
      }
    });

    formValidation();
  };

  /**
   * Only expose the ready function to the world
   */
  return {
    ready: ready,
  };
})(jQuery);

jQuery(common.ready);
